<app-replace-file-dialog></app-replace-file-dialog>
<app-invoice-upload-dialog [toast]="toast"></app-invoice-upload-dialog>
<app-toast></app-toast>
<app-invoice-file-dispute-dialog></app-invoice-file-dispute-dialog>

<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <app-desktop-topbar pageName="{{ 'shared.pages.invoice' | transloco }}"
            class="mobile:hidden"></app-desktop-topbar>
        <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
        <div class="flex gap-6 items-center mobile:justify-evenly">
            <app-tab-button label="{{ 'shared.electricity' | transloco }}" link="/invoice/electricity"></app-tab-button>
            <app-tab-button label="{{ 'shared.gas' | transloco }}" [isActive]="true"
                link="/invoice/gas"></app-tab-button>
        </div>

        <!-- Invoices -->
        <div class="mt-4 rounded-[16px] w-auto max-w-ultrawide border-[1px] border-neutral-200 shadow-sm">
            <div class="flex flex-col gap-2">
                <div class="flex flex-wrap justify-between items-center mx-4 mobile:flex-col mobile:p-6">
                    <h3 class="font-bold mobile:mb-6">{{ 'invoice.invoices' | transloco }}</h3>
                    <div class="flex flex-wrap gap-2 min-h-[70px] items-center mobile:flex-col mobile:h-auto">
                        <div class="w-[300px]">
                            <app-custom-dropdown [options]="filterDropdownOptions"
                                [(selectedOption)]="selectedFilterDropdown"
                                (selectedOptionChange)="applySelectedFilter()"></app-custom-dropdown>
                        </div>

                        <label class="input input-bordered flex items-center gap-2 w-auto max-w-[300px]">
                            <img src="assets/icons/search-normal.svg" alt="{{ 'shared.icon' | transloco }}">
                            <input type="text" class="grow" [(ngModel)]="searchTerm" (keyup)="applySearchFilter()"
                                placeholder="{{ 'shared.search' | transloco }}" />
                        </label>

                        <div class="w-[150px] h-[50px]">
                            <app-custom-button buttonText="{{ 'invoice.upload_file' | transloco }}"
                                (click)="openInvoiceUploadDialog()" leadingIcon="assets/icons/add.svg"
                                backgroundColor="bg-primary" textColor="text-white" borderColor="border-primary"
                                hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>
                        </div>

                        <div class="w-[150px] h-[50px]">
                            <app-custom-button buttonText="{{ 'invoice.csv_export' | transloco }}"
                                backgroundColor="bg-secondary-600" textColor="text-white"
                                borderColor="border-secondary-600" hoverBackgroundColor="hover:bg-secondary"
                                hoverBorderColor="hover:border-secondary"
                                (buttonClick)="exportCsv()"></app-custom-button>
                        </div>
                    </div>
                </div>

                <!--Separator-->
                <div class="w-full h-[1px] bg-border"></div>

                <div
                    class="overflow-x-auto max-w-ultrawide justify-center mb-4 mobile:max-w-screen h-full block min-h-[70vh]">
                    <table class="table w-full">
                        <!-- Header -->
                        <thead class="bg-primary-100 text-neutral-700 uppercase">
                            <tr class="max-h-[50px]">
                                <th class="border-b border-border px-4 py-4 font-normal">{{ 'invoice.period' | transloco
                                    }}</th>
                                <th class="border-b border-border px-4 py-4 font-normal">{{
                                    'archive.overview.file_name' |
                                    transloco
                                    }}</th>
                                <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.invoice_number' |
                                    transloco }}</th>
                                <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.consumption' |
                                    transloco }}</th>
                                <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.costs' | transloco
                                    }}</th>
                                <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.status' | transloco
                                    }}</th>
                                <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.details' | transloco
                                    }}</th>
                            </tr>
                        </thead>
                        <!-- Content -->
                        <tbody>
                            <ng-container *ngFor="let invoice of invoices; let i = index">
                                <tr [ngClass]="[expandedRow === i ? 'bg-primary text-white hover:bg-primary-1200' : 'hover:bg-neutral-200']"
                                    class="max-h-[50px] hover:cursor-pointer" (click)="toggleDetails(i)">
                                    <td class="border-b border-border px-4 py-4">{{ invoice.for_period ?? '' | isoPeriod
                                        }}</td>
                                    <td class="border-b border-border px-4 py-4">{{ invoice.file.filename }}</td>
                                    <td class="border-b border-border px-4 py-4">{{ invoice.invoice_number }}</td>
                                    <td class="border-b border-border px-4 py-4">{{ invoice.total_consumption |
                                        number:'1.2-2' }} {{
                                        'shared.smc' | transloco }}</td>
                                    <td class="border-b border-border px-4 py-4">{{ invoice.invoice_amount_net_actual |
                                        number:'1.2-2'
                                        }} €</td>
                                    <td class="border-b border-border px-4 py-4"><app-invoice-status
                                            [statusEnum]="invoice.status" [visibilityStatus]="invoice.visibility_status"
                                            statusOkColor="#80A7A5"></app-invoice-status>
                                    </td>
                                    <td class="border-b border-border px-4 py-4"> <button>
                                            <p class="text-primary hover:underline" *ngIf="expandedRow !== i">
                                                {{ 'invoice.view_details' | transloco }}</p>
                                            <p class="text-white hover:underline" *ngIf="expandedRow === i">
                                                {{ 'invoice.close_details' | transloco }}</p>
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="expandedRow === i">
                                    <td colspan="7" class="border-b border-border px-4 py-4" @expandRow>
                                        <app-expanded-gas-invoice [invoice]="invoice" [toast]="toast"
                                            [disputeDialog]="disputeDialog" [reloadCallbackFunction]="reloadInvoices"
                                            statusOkColor="#80A7A5"></app-expanded-gas-invoice>
                                    </td>
                                </tr>
                            </ng-container>
                            <tr *ngIf="loadedInvoices.length > 0 && !loadMoreHidden">
                                <td colspan="7">
                                    <div class="w-full h-full flex justify-center items-start">
                                        <div class="w-[150px] h-[50px]">
                                            <app-custom-button buttonText="{{ 'shared.load_more' | transloco }}"
                                                [isDisabled]="false" backgroundColor="bg-neutral-500"
                                                textColor="text-white" borderColor="border:bg-neutral-500"
                                                hoverBackgroundColor="hover:bg-neutral-1200"
                                                (buttonClick)="loadGasInvoicesNewPage()">
                                            </app-custom-button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>